<template>
  <div
    class="graph-result"
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <div
      class="graph"
      :style="{ width: width + 'px', height: height + 'px' }"
      ref="graphChart"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
export default {
  // props: ["graphData"],
  props: {
    graphData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    width: {
      type: Number,
      default: 720 // 默认宽度
    },
    height: {
      type: Number,
      default: 400 // 默认高度
    }
  },
  data() {
    return {};
  },
  watch: {
    graphData: {
      handler(newVal) {
        this.$nextTick(() => {
          this.initChat();
        });
      },
      immediate: false, // 立即触发一次回调
      deep: true // 深度监听对象内部的变化
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChat();
    });
  },
  methods: {
    initChat() {
      // 如果图表实例已存在，销毁它
      // if (
      //   this.$refs.graphChart &&
      //   echarts.getInstanceByDom(this.$refs.graphChart)
      // ) {
      //   echarts.dispose(this.$refs.graphChart);
      // }

      const nodesData = this.graphData.nodes.map((node) => {
        return {
          name: node.id,
          desc: node.description,
          itemStyle: {
            color: node.color || "#999999"
          }
        };
      });
      const linksData = this.graphData.links.map((link) => {
        return {
          source: link.source,
          target: link.target,
          desc: link.description,
          lineStyle: {
            color: link.color,
            // color: "source",
            width: link.weight,
            opacity: 0.1,
            curveness: 0.2
          }
          //  label: {
          //      show: true,
          //      formatter: link.description
          //  }
        };
      });

      // const categoriesData = this.graphData.summaryGroups.map((category) => {
      //   return {
      //     name: category.group,
      //     description: category.summary,
      //     itemStyle: {
      //       color: category.color
      //     }
      //   };
      // });

      const newData = {
        data: nodesData,
        links: linksData
        // categories: categoriesData
      };
      // 初始化echarts实例
      const myChart = echarts.init(this.$refs.graphChart, "null", {
        renderer: "canvas" // 以svg渲染可以减少内存消耗
      });
      const option = {
        //  title: {
        //    text: "关系图谱",
        //    padding: [20, 0, 0, 20]
        //  },
        tooltip: {
          trigger: "item", // 触发类型，'item' 表示数据项图形触发，'axis' 表示坐标轴触发
          // 显示策略，可选为：true（显示） | false（隐藏），也可以是一个回调函数，根据参数判断是否显示
          show: true,
          formatter: function (params) {
            // params is the current tooltip data item
            return (
              '<div class="tooltip-content"><h5>' +
              params.name +
              "</h5>" +
              params.data.desc +
              "</div>"
            );
          }
        },
        legend: [
          {
            show: true,
            top: 56,
            // orient: 'vertical',
            left: 18,
            width: 400, // 设置最大宽度为 400px
            // data: _data,

            // formatter: function (legendName) {
            //   // 找到与图例名匹配的数据项
            //   // let dataItem = option.legend[0].data.find(function (item) {
            //   //   return item.name === legendName;
            //   // });
            //   // 返回自定义的图例文本
            //   // return legendName + ' - ' + dataItem.description;
            //   return `社区摘要${legendName}`;
            // },
            rich: {
              a: {
                color: "red",
                lineHeight: 10
              },
              b: {
                color: "green",
                height: 40
              }
            }
          }
        ],
        animationDurationUpdate: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            type: "graph",
            layout: "force",
            force: {
              // initLayout: 'circular',
              repulsion: 100, // 斥力因子，值越大则斥力越大
              gravity: 0.12, // 节点受到的向中心的引力因子，该值越大节点越往中心点靠拢
              edgeLength: 123 // 边的两个节点之间的距离，这个距离也会受 repulsion，值越大则节点距离越远
            },
            draggable: true, // 节点可拖拽
            symbolSize: 10,
            roam: false,
            zoom: 1.2,
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [5, 15],
            label: {
              show: true,
              position: "bottom",
              distance: 4,
              fontSize: 12,
              align: "center"
            },
            edgeLabel: {
              show: false,
              fontSize: 12,
              formatter: "{c}"
            },

            data: newData.data,
            links: newData.links,
            //    lineStyle: {
            //      color: "#eee",
            //      opacity: 0.5,
            //     //  width: 2,
            //      curveness: 0
            //    },
            emphasis: {
              focus: "series",
              lineStyle: {
                // width: 4,
              }
            }
            // categories: newData.categories
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      //  myChart.clear();
      // myChart.setOption(option, true);

      // Chart.clear();
      // Chart.setOption(option);
      // window.addEventListener("resize", () => {
      //   // 页面大小变化后Echarts也更改大小
      //   Chart.resize();
      // });

      // ... 其他图表配置和数据设置 ...
      myChart.setOption(option);

      // 监听窗口大小变化，并更新图表大小
      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.graph-result {
  // width: 735px;
  // height: 420px; /* 设置合适的高度 */
  margin: 0 auto;
}
.graph {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
::v-deep .tooltip-content {
  display: inline-block;
  max-width: 200px;
  white-space: normal;
}
</style>
